import { Outlet } from "react-router-dom";

const PageLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default PageLayout;
